/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Version_Incompatible_MessageInputs */

const en_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It looks like you're using a version of Brave that's not compatible with Leo AI. Please update to the latest version of Brave to use Leo AI.`)
};

const id_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepertinya Anda menggunakan Brave dengan versi yang tidak kompatibel dengan Leo AI. Update Brave ke versi terbaru agar dapat menggunakan Leo AI.`)
};

const ms_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelihatannya seperti anda sedang menggunakan versi Brave yang tidak sesuai dengan Leo AI. Sila kemas kini kepada versi terkini Brave untuk menggunakan Leo AI.`)
};

const ca_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembla que estàs utilitzant una versió de Brave que no és compatible amb la IA Leo. Per poder fer servir la IA Leo, actualitza Brave a la versió més recent.`)
};

const cs_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdá se, že používáte verzi Brave, která není s Leo AI kompatibilní. Chcete-li používat Leo AI, aktualizujte Brave na nejnovější verzi.`)
};

const da_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det ser ud til, at du bruger en version af Brave, der ikke er kompatibel med Leo AI. Opdater venligst til den nyeste version af Brave for at bruge Leo AI.`)
};

const de_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anscheinend verwendest du eine Version von Brave, die nicht mit Leo AI kompatibel ist. Bitte aktualisiere Brave auf die neueste Version, um Leo AI nutzen zu können.`)
};

const et_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paistab, et kasutate Brave'i versiooni, mis ei ühildu Leo AI-ga. Leo AI kasutamiseks värskendage Brave uusimale versioonile.`)
};

const es_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parece que estás usando una versión de Brave que no es compatible con Leo AI. Para usar Leo AI, actualiza a la versión más reciente de Brave.`)
};

const fr_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il semble que votre version actuelle de Brave ne soit pas compatible avec Leo AI. Veuillez mettre à jour votre appareil avec la dernière version de Brave.`)
};

const hr_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izgleda da koristite verziju Bravea koja nije kompatibilna s uslugom Leo AI. Ažurirajte Brave na najnoviju verziju kako biste mogli koristiti Leo AI.`)
};

const it_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembra che tu stia usando una versione di Brave non compatibile con Leo AI. Per usare Leo AI, aggiorna Brave alla versione più recente.`)
};

const lv_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šķiet, jūs izmantojat ar Leo MI nesavietojamu Brave versiju. Lūdzu, atjauniniet Brave uz jaunāko versiju, lai lietotu Leo MI.`)
};

const lt_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrodo, kad naudojate „Brave“ versiją, kuri nesuderinama su „Leo“ dirbtiniu intelektu. Norėdami naudoti „Leo“ dirbtinį intelektą, atnaujinkite „Brave“ į naujausią versiją.`)
};

const hu_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A jelenlegi Brave-verzió nem támogatja a Leo AI-t. Kérjük, frissítsen a legújabb verzióra.`)
};

const nl_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zo te zien gebruik je een versie van Brave die niet compatibel is met Leo AI. Werk bij naar de nieuwste versie van Brave om Leo AI te gebruiken.`)
};

const nb_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det ser ut til at du bruker en versjon av Brave som ikke er kompatibel med Leo AI. Du må oppdatere til den nyeste versjonen av Brave for å bruke Leo AI.`)
};

const pl_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygląda na to, że używasz wersji Brave, która nie jest zgodna z Leo AI. Zaktualizuj Brave do najnowszej wersji, aby korzystać z Leo AI.`)
};

const pt_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parece que você está usando uma versão do Brave que não é compatível com o Leo AI. Atualize para a versão mais recente do Brave para usar o Leo AI.`)
};

const ro_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se pare că folosești o versiune a Brave care nu este compatibilă cu Leo AI. Te rugăm să actualizezi la ultima versiune de Brave pentru a folosi Leo AI.`)
};

const sk_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdá sa, že používate verziu Brave, ktorá nie je kompatibilná s Leo AI. Ak chcete používať Leo AI, aktualizujte na najnovšiu verziu Brave.`)
};

const sl_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdi se, da uporabljate različico programa Brave, ki ni združljiva s storitvijo Leo AI. Če želite uporabljati storitev Leo AI, posodobite Brave na najnovejšo različico.`)
};

const fi_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näyttää siltä, että käytät Brave-versiota, joka ei ole yhteensopiva Leo AI:n kanssa. Päivitä uusimpaan Brave-versioon, jotta voit käyttää Leo AI:ta.`)
};

const sv_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det ser ut som att du använder en version av Brave som inte är kompatibel med Leo AI. Vänligen uppdatera till den senaste versionen av Brave för att använda Leo AI.`)
};

const vi_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có vẻ bạn đang sử dụng một phiên bản Brave không tương thích với Leo AI. Vui lòng cập nhật lên phiên bản mới nhất của Brave để sử dụng Leo AI.`)
};

const tr_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görünüşe göre Leo YZ ile uyumlu olmayan bir Brave sürümü kullanıyorsunuz. Leo YZ kullanmak için lütfen Brave'i en son sürümüne güncelleyin.`)
};

const el_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φαίνεται ότι χρησιμοποιείτε μια έκδοση του Brave που δεν είναι συμβατή με το Leo AI. Ενημερώστε στην τελευταία έκδοση του Brave για να χρησιμοποιήσετε το Leo AI.`)
};

const bg_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изглежда използваш версия на Brave, която не е съвместима с Leo AI. Моля, актуализирай до най-новата версия на Brave, за да използваш Leo AI.`)
};

const ru_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кажется, вы используете версию Brave, которая не совместима с Leo AI. Пожалуйста, обновите до последней версии Brave для использования Leo AI.`)
};

const sr_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изгледа да користите верзију Brave-а која није компатибилна са асистентом Leo AI. Ажурирајте Brave на најновију верзију да бисте користили асистента Leo AI.`)
};

const uk_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схоже, ви використовуєте версію Brave, несумісну з Leo AI. Будь ласка, оновіть Brave до останньої версії, щоб використовувати Leo AI.`)
};

const ka_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`როგორც ჩანს, თქვენ იყენებთ Brave-ის ვერსიას, რომელიც Leo AI-სთან არ არის თავსებადი. Leo AI-ის გამოსაყენებლად, გთხოვთ, განაახლოთ Brave უახლეს ვერსიამდე.`)
};

const hi_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऐसा लगता है कि आप ब्रेव का ऐसा वर्शन इस्तेमाल कर रहे हैं जो लियो एआई के साथ कम्पेटिबल नहीं है। लियो एआई का इस्तेमाल करने के लिए कृपया ब्रेव का लेटेस्ट वर्शन अपडेट करें।`)
};

const th_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูเหมือนว่าเวอร์ชันของ Brave ที่คุณใช้อยู่จะไม่รองรับกับ Leo AI กรุณาอัปเดต Brave เป็นเวอร์ชันล่าสุดเพื่อใช้ Leo AI`)
};

const ko_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레오 AI와 호환되지 않는 버전의 Brave를 사용 중인 것 같습니다. 레오 AI를 사용하려면 최신 버전의 Brave로 업데이트하세요.`)
};

const zh_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您正在使用的 Brave 版本似乎与 Leo 人工智能不兼容。请更新到最新版本的 Brave 以使用 Leo 人工智能。`)
};

const zh_tw_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您目前使用的 Brave 瀏覽器版本似乎與 Leo AI 不相容。請更新至 Brave 最新版本以使用 Leo AI。`)
};

const ja_leo_version_incompatible_message = /** @type {(inputs: Leo_Version_Incompatible_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご使用中のBraveは互換性のないバージョンのようです。Leo AIを使用するには、Braveを最新バージョンにアップレートしてください。`)
};

/**
* | output |
* | --- |
* | "It looks like you're using a version of Brave that's not compatible with Leo AI. Please update to the latest version of Brave to use Leo AI." |
*
* @param {Leo_Version_Incompatible_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_version_incompatible_message = /** @type {((inputs?: Leo_Version_Incompatible_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Version_Incompatible_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_version_incompatible_message(inputs)
	if (locale === "ms") return ms_leo_version_incompatible_message(inputs)
	if (locale === "ca") return ca_leo_version_incompatible_message(inputs)
	if (locale === "cs") return cs_leo_version_incompatible_message(inputs)
	if (locale === "da") return da_leo_version_incompatible_message(inputs)
	if (locale === "de") return de_leo_version_incompatible_message(inputs)
	if (locale === "et") return et_leo_version_incompatible_message(inputs)
	if (locale === "es") return es_leo_version_incompatible_message(inputs)
	if (locale === "fr") return fr_leo_version_incompatible_message(inputs)
	if (locale === "hr") return hr_leo_version_incompatible_message(inputs)
	if (locale === "it") return it_leo_version_incompatible_message(inputs)
	if (locale === "lv") return lv_leo_version_incompatible_message(inputs)
	if (locale === "lt") return lt_leo_version_incompatible_message(inputs)
	if (locale === "hu") return hu_leo_version_incompatible_message(inputs)
	if (locale === "nl") return nl_leo_version_incompatible_message(inputs)
	if (locale === "nb") return nb_leo_version_incompatible_message(inputs)
	if (locale === "pl") return pl_leo_version_incompatible_message(inputs)
	if (locale === "pt") return pt_leo_version_incompatible_message(inputs)
	if (locale === "ro") return ro_leo_version_incompatible_message(inputs)
	if (locale === "sk") return sk_leo_version_incompatible_message(inputs)
	if (locale === "sl") return sl_leo_version_incompatible_message(inputs)
	if (locale === "fi") return fi_leo_version_incompatible_message(inputs)
	if (locale === "sv") return sv_leo_version_incompatible_message(inputs)
	if (locale === "vi") return vi_leo_version_incompatible_message(inputs)
	if (locale === "tr") return tr_leo_version_incompatible_message(inputs)
	if (locale === "el") return el_leo_version_incompatible_message(inputs)
	if (locale === "bg") return bg_leo_version_incompatible_message(inputs)
	if (locale === "ru") return ru_leo_version_incompatible_message(inputs)
	if (locale === "sr") return sr_leo_version_incompatible_message(inputs)
	if (locale === "uk") return uk_leo_version_incompatible_message(inputs)
	if (locale === "ka") return ka_leo_version_incompatible_message(inputs)
	if (locale === "hi") return hi_leo_version_incompatible_message(inputs)
	if (locale === "th") return th_leo_version_incompatible_message(inputs)
	if (locale === "ko") return ko_leo_version_incompatible_message(inputs)
	if (locale === "zh") return zh_leo_version_incompatible_message(inputs)
	if (locale === "zh-tw") return zh_tw_leo_version_incompatible_message(inputs)
	if (locale === "ja") return ja_leo_version_incompatible_message(inputs)
	return en_leo_version_incompatible_message(inputs)
});